<h1 mat-dialog-title>
    <span [translate]="'admin.bibliotheque.notifications.accueil.detail.ajoutRole.title'"></span>
    <span [mat-dialog-close]><i class="zmdi zmdi-close"></i></span>
</h1>
<div mat-dialog-content>
    <list-view *ngIf="listeRoles" [liste]="listeRoles"></list-view>
</div>
<div mat-dialog-actions style="justify-content: space-between">
    <div>
        <button mat-stroked-button color="primary" (click)="onUnselectAll()">
            <span [translate]="'global.actions.toutDeselectionner'"></span>
        </button>
        <button mat-stroked-button color="primary" (click)="onSelectAll()">
            <span [translate]="'global.actions.toutSelectionner'"></span>
        </button>
    </div>
    <div>
        <button mat-flat-button color="primary" [mat-dialog-close]>
            <span translate>global.actions.annuler</span>
        </button>
        <button mat-flat-button color="primary" [mat-dialog-close]="listeRoles.listeObjetsSectionnes">
            <span translate>global.actions.ajouter</span>
        </button>
    </div>
</div>
